import { render, staticRenderFns } from "./richWater.vue?vue&type=template&id=8a8c5b24&scoped=true"
import script from "./richWater.vue?vue&type=script&lang=js"
export * from "./richWater.vue?vue&type=script&lang=js"
import style0 from "./richWater.vue?vue&type=style&index=0&id=8a8c5b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c5b24",
  null
  
)

export default component.exports